export const deleteLanguage = ({ BeURL, showAlert, setLanguage, id }) => {
    fetch(`${BeURL}/language-delete/${id}`, {
        method: "DELETE",
        credentials: "include",
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setLanguage(data.languages)
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in delete language", err);
        });
}
